import React from "react";
import MyDropdown from "../../../../Common/my-dropdown/my-dropdown-new.component";
import PlusIcon from "../../../../icons/plus.icon";
import { TechnologyListItem } from "../../../../../common/types/tool.types";

interface AddTechnologyDropdownProps {
  filteredTechnologiesList: TechnologyListItem[];
  canSelectMoreTechnologies: boolean;
  values: {
    technologiesList: TechnologyListItem[];
  };
  setFieldValue: (field: string, value: any) => void;
}

const AddTechnologyDropdown: React.FC<AddTechnologyDropdownProps> = ({
  filteredTechnologiesList,
  canSelectMoreTechnologies,
  values,
  setFieldValue,
}) => {
  if (!canSelectMoreTechnologies) {
    return null;
  }

  return (
    <MyDropdown className="w-fit-content">
      <MyDropdown.Toggle className="update-tool-form__add-button my-button d-flex align-items-center gap-4" hideArrow>
        <div className="d-flex flex-column gap-4 align-items-start">
          <div className="d-flex align-items-center gap-4 pl-3">
            <div className="update-tool-form__add-button-icon">
              <PlusIcon width="12px" height="12px" fill="#616778" />
            </div>
            <span className="f-14 line-height-22 f-500 f-grey">
              Add
            </span>
          </div>
        </div>
      </MyDropdown.Toggle>
      <MyDropdown.Menu className="w-fit-content no-wrap f-grey hide-scrollbar" popperConfig={{ strategy: "fixed" }} renderOnMount>
        <div>
          {filteredTechnologiesList.length > 0 ? (
            filteredTechnologiesList.map((item, index) => {
              return (
                <MyDropdown.Item key={index} className="d-flex align-items-center gap-8" onClick={() => {
                  const current = values.technologiesList || [];
                  const next = [...current, { ...item, selected: true }];
                  setFieldValue('technologiesList', next);
                }}>
                  <span>{item.label}</span>
                </MyDropdown.Item>
              );
            })
          ) : (
            <div className="d-flex align-items-center justify-content-center p-3">
              <span className="f-14 f-grey">No technologies available</span>
            </div>
          )}
        </div>
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default AddTechnologyDropdown;

